import React, {PureComponent} from 'react';
import ReactIntlTelInput from 'react-intl-tel-input-v2';

import { Callout, Intent, ProgressBar } from '@blueprintjs/core';

import InputRegular from '../../common/InputRegular';

export default class AccountVerificationRepresentativeDetails extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            spinnerActive: false,
            fieldsCheckActive: false,
            errorsList: [],
            termsChecked: false
        };
    }

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    getFullPhoneNumber = (phoneObject) =>{
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')){
            phone = phone.substring(2);
            phone = '+' + phone;
            return phone
        } else if (phone.startsWith('0')){
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            return phone
        } else if (phone.startsWith('+')){
            return phone
        } else if(phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            return phone
        } else {
            return ''
        }
    }

    isPhoneNumber = (phone) => {
        // let phone = this.state.phone.phone;
        var regEx = /^[+-]?\d+$/;
        if (regEx.test(phone) && phone.length > 6) {
            return true
        } else {
            return false
        }
    }

    handleUpdatePhone = async (e) => {
        await this.props.handleUpdateProperty(window.location.pathname === '/account-verification/authorized-representative-details' ?
            'authorizedRepresentative' :  'clientContactPersonDetails', 'phone', e);
        await this.props.handleUpdateProperty(window.location.pathname === '/account-verification/authorized-representative-details' ?
            'authorizedRepresentative' :  'clientContactPersonDetails','formatedPhone', this.getFullPhoneNumber(e));
        // console.log('formatedPhone: ', this.getFullPhoneNumber(e), this.props.personalDetails.formatedPhone)
    }

    handleSubmit = async (finalStep) => {
        await this.setState({ fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = await false
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            // console.log('errorsList: ',anyErrorActive, this.state.errorsList)
            // if(!anyErrorActive && ((window.location.pathname === '/account-verification/personal-details') &&
            //         this.props.personalDetails && this.props.personalDetails.files.length &&
            //         (this.props.personalDetails.country !== 'Select Country')) ||
            //     ((window.location.pathname === '/account-verification/business-details') &&
            //         this.props.businessDetails && this.props.businessDetails.files.length &&
            //         (this.props.businessDetails.country !== 'Select Country')) ||
            //     ((window.location.pathname === '/account-verification/client-business-details') &&
            //         (this.props.clientBusinessDetails.country !== 'Select Country'))
            // ){
            if((window.location.pathname === '/account-verification/authorized-representative-details') &&
                !anyErrorActive && this.isPhoneNumber(this.props.authorizedRepresentative.formatedPhone)){
                    await this.props.handleSubmitBusinessDetails(finalStep);
                    await this.setState({
                        fieldsCheckActive: false,
                    })
            }else if((window.location.pathname === '/account-verification/client-contact-person-details') &&
                !anyErrorActive && this.isPhoneNumber(this.props.clientContactPersonDetails.formatedPhone)){
                    await this.props.handleSubmitBusinessDetails(finalStep);
                    await this.setState({
                        fieldsCheckActive: false,
                    })
            }
        }, 300)
    }

    componentDidMount() {
    }

    render() {
        const inputProps = {
            placeholder: window.location.pathname === '/account-verification/authorized-representative-details' ?
                    '+' + this.props.authorizedRepresentative.phone.dialCode + ' *********'
                    :
                    '+' + this.props.clientContactPersonDetails.phone.dialCode + ' *********',
            disabled: this.props.stepVerified
        };

        const intlTelOpts = {
            preferredCountries: [],
        };

        return (
            <div>
                {
                    window.location.pathname === '/account-verification/authorized-representative-details' && this.props.authorizedRepresentative.usingOnBehalfOf === 'My Client Business' ?
                        <div className='progress-bar-container'>
                            <p style={ { position: 'absolute', left: '48%', top: 0, transition: '0.2s'}}>50%</p>
                            <ProgressBar intent='primary' value={ 0.5 } animate={ false } stripes={ false }/>
                        </div>
                        :
                        <div className='progress-bar-container'>
                            <p style={ { position: 'absolute', left: '75%', top: 0, transition: '0.2s' }}>80%</p>
                            <ProgressBar intent='primary' value={ 0.8 } animate={ false } stripes={ false }/>
                        </div>
                }
                {
                    window.location.pathname === '/account-verification/authorized-representative-details' ?
                        <h1>Authorized Representative Details</h1>
                        :
                        window.location.pathname === '/account-verification/client-contact-person-details' ?
                            <h1>Client Contact Person Details</h1>
                            :
                            ''
                }

                {this.props.verificationRejected ?
                    this.props.stepVerified ?
                        <Callout icon='tick' intent={ Intent.SUCCESS }>This section was successfully verified!</Callout>
                        :
                        <Callout intent={'danger'} icon={'warning-sign'}>You need to re-submit this section!</Callout>
                    :
                    ''
                }

                <div className='inputs-container'>
                    <InputRegular
                        id="1"
                        label1="First Name"
                        placeholder="First Name"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/authorized-representative-details' ?
                                'authorizedRepresentative' : 'clientContactPersonDetails', 'firstName', value)
                        }
                        value={window.location.pathname === '/account-verification/authorized-representative-details' ?
                            this.props.authorizedRepresentative.firstName : this.props.clientContactPersonDetails.firstName}
                        required={true}
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="First name is required"
                        disabled={this.props.stepVerified}
                    />
                    <InputRegular
                        id="2"
                        label1="Last Name"
                        placeholder="Last Name"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/authorized-representative-details' ?
                                'authorizedRepresentative' : 'clientContactPersonDetails', 'lastName', value)
                        }
                        value={window.location.pathname === '/account-verification/authorized-representative-details' ?
                            this.props.authorizedRepresentative.lastName : this.props.clientContactPersonDetails.lastName}
                        required={true}
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="Last name is required"
                        disabled={this.props.stepVerified}
                    />
                    <InputRegular
                        id="3"
                        label1="Email"
                        placeholder="Email"
                        type='email'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/authorized-representative-details' ?
                                'authorizedRepresentative' : 'clientContactPersonDetails', 'email', value)
                        }
                        value={window.location.pathname === '/account-verification/authorized-representative-details' ?
                            this.props.authorizedRepresentative.email : this.props.clientContactPersonDetails.email}
                        required={true}
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="Email is required"
                        disabled={this.props.stepVerified}
                    />
                    <div className={ this.props.stepVerified ? "margin-bottom-10 opacity-05" : "margin-bottom-10"}>
                        <p htmlFor="post-link" className='full-row-label'>Phone</p>
                        <ReactIntlTelInput
                            className={
                                window.location.pathname === '/account-verification/authorized-representative-details' ?
                                    ((this.props.authorizedRepresentative.formatedPhone === '') || !this.isPhoneNumber(this.props.authorizedRepresentative.phone.phone) )
                                    && this.state.fieldsCheckActive ? 'onboard-tel error' :
                                        this.props.authorizedRepresentative.formatedPhone === '' ? '' : 'onboard-tel valid'
                                    :
                                    ((this.props.clientContactPersonDetails.formatedPhone === '') || !this.isPhoneNumber(this.props.clientContactPersonDetails.phone.phone) )
                                    && this.state.fieldsCheckActive ? 'onboard-tel error' :
                                        this.props.clientContactPersonDetails.formatedPhone === '' ? '' : 'onboard-tel valid'
                            }
                            inputProps={inputProps}
                            intlTelOpts={intlTelOpts}
                            value={window.location.pathname === '/account-verification/authorized-representative-details' ?
                                this.props.authorizedRepresentative.phone : this.props.clientContactPersonDetails.phone
                            }
                            onChange={(e) => this.handleUpdatePhone(e) }
                            // onReady={onReady}
                        />
                        {
                            (
                                ((window.location.pathname === '/account-verification/authorized-representative-details') &&
                                ((this.props.authorizedRepresentative.phone.phone === '') ||
                                !this.isPhoneNumber(this.props.authorizedRepresentative.phone.phone)))
                                ||
                                ((window.location.pathname === '/account-verification/client-contact-person-details') &&
                                ((this.props.clientContactPersonDetails.phone.phone === '') ||
                                !this.isPhoneNumber(this.props.clientContactPersonDetails.phone.phone)))
                            ) &&
                            this.state.fieldsCheckActive ?
                                <div className="selector-error-label">Valid phone number is required</div>
                                :
                                <div className='selector-error-label'></div>
                        }
                    </div>
                </div>


                {
                    window.location.pathname === '/account-verification/authorized-representative-details' ?
                        <h2>I will be using Emitto on behalf of</h2>
                        :
                        ''
                }
                {
                    window.location.pathname === '/account-verification/authorized-representative-details' ?
                        <div className={this.props.stepVerified ? 'tabs-navigation opacity-05' : 'tabs-navigation'}>
                            <div
                                onClick={this.props.stepVerified ? '' : ()=>this.props.handleUpdateProperty('authorizedRepresentative', 'usingOnBehalfOf', 'This Business')}
                                className={this.props.authorizedRepresentative.usingOnBehalfOf === 'This Business' ? "navigation-tab active" : "navigation-tab"}>
                                <p>This Business</p>
                            </div>
                            <div
                                onClick={this.props.stepVerified ? '' : ()=>this.props.handleUpdateProperty('authorizedRepresentative', 'usingOnBehalfOf', 'My Client Business')}
                                className={this.props.authorizedRepresentative.usingOnBehalfOf === 'My Client Business' ? "navigation-tab active" : "navigation-tab"}>
                                <p>My Client Business</p>
                            </div>
                        </div>
                        :
                        ''
                }
                {
                    (window.location.pathname === '/account-verification/client-contact-person-details') ||
                    ((window.location.pathname === '/account-verification/authorized-representative-details') && (this.props.authorizedRepresentative.usingOnBehalfOf === 'This Business') )  ?
                        <p className='terms-checkbox'><input className='checkbox' type="checkbox" checked={this.state.termsChecked}
                                  onChange={()=>this.setState({termsChecked: !this.state.termsChecked})}/> By
                            Submitting this form, I agree to the  <a target='_blank' href="https://emitto.io/terms-of-service"> Terms of Service, </a>
                            <a target='_blank' href="https://app.emitto.io/privacy"> Privacy Policy</a> and
                            <a href='https://emitto.io/know-your-customer-policy' target='_blank'> KYC Policy</a>.
                        </p>
                        :
                        ''
                }

                {
                    window.location.pathname === '/account-verification/authorized-representative-details' && this.props.authorizedRepresentative.usingOnBehalfOf === 'My Client Business' ?
                        <div className='bottom-with-buttons space'>
                            <button className="btn-white-border" onClick={() => this.props.history.push('/account-verification/business-details')}>Previous</button>
                            { this.props.spinner ?
                                <button className='btn-action btn-spinner' disabled={ true }>Next <i className='fa fa-spin fa-spinner'></i>
                                </button>
                                :
                                <button className='btn-action' onClick={ this.props.stepVerified ? ()=>this.props.history.push('/account-verification/client-business-details') :
                                    ()=>this.handleSubmit(false) }>Next</button>
                            }
                        </div>
                        :
                        window.location.pathname === '/account-verification/authorized-representative-details' && this.props.authorizedRepresentative.usingOnBehalfOf === 'This Business' ?
                            <div className='bottom-with-buttons space'>
                                <button className="btn-white-border" onClick={() => this.props.history.push('/account-verification/business-details')}>Previous</button>
                                { this.props.spinner ?
                                    <button className='btn-action btn-spinner' disabled={ true }>Submit <i className='fa fa-spin fa-spinner'></i>
                                    </button>
                                    :
                                    <button disabled={!this.state.termsChecked} className='btn-action' onClick={ ()=>this.handleSubmit(true) }>Submit</button>
                                }
                            </div>
                            :
                            window.location.pathname === '/account-verification/client-contact-person-details' ?
                                <div className='bottom-with-buttons space'>
                                    <button className="btn-white-border" onClick={() => this.props.history.push('/account-verification/client-business-details')}>Previous</button>
                                    { this.props.spinner ?
                                        <button className='btn-action btn-spinner' disabled={ true }>Submit <i className='fa fa-spin fa-spinner'></i>
                                        </button>
                                        :
                                        <button disabled={!this.state.termsChecked} className='btn-action' onClick={ ()=>this.handleSubmit(true) }>Submit</button>
                                    }
                                </div>
                                :
                                ''
                }
            </div>
        )
    }
}
